<template>
  <div class="menu-list">
    <template v-for="item in menu">
      <el-submenu v-if="item.answerList && item.answerList.length > 0" 
        :key="item.id"
        :index="index + '-' + item.id"
        @click="menuClick('0-' + item.id)"
        class="level-1">
        <span slot="title">{{item.aliasName}}</span>
        <template v-for="aItem in item.answerList">
            <el-submenu v-if="aItem.subAnswerList && aItem.subAnswerList.length > 0" 
              :key="aItem.id"
              :index="index + '-' + item.id + '-' + aItem.id"
              @click="menuClick(index + '-' + item.id + '-' + aItem.id)"
              class="level-2">
                <span slot="title">{{aItem.aliasName}}</span>
                <template v-for="subItem in aItem.subAnswerList">
                    <el-menu-item
                      :key="subItem.id"
                      :index="index + '-' + item.id + '-' + aItem.id + '-' + subItem.id"
                      @click="menuClick(index + '-' + item.id + '-' + aItem.id + '-' + subItem.id)"
                      class="level-3">
                      <span slot="title">{{subItem.aliasName}}</span></el-menu-item>
                </template>
            </el-submenu>
            <el-menu-item
              v-else 
              class="level-2"
              :key="aItem.id"
              :index="index + '-' + item.id + '-' + aItem.id"
              @click="menuClick(index + '-' + item.id + '-' + aItem.id)">{{aItem.aliasName}}</el-menu-item>
        </template>
      </el-submenu>
      <el-menu-item v-else 
        :key="item.id"
        :index="index + '-' + item.id"
        @click="menuClick(index + '-' + item.id)"
        class="level-1">{{item.aliasName}}</el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: 'menu-question',
  props: {
    menu: {
      type: Array,
      default: () => {
        return []
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    menuClick(key) {
      this.$emit("menuClick", key.split("-"), this.index)
    }
  }
}
</script>

<style scoped>
.menu-list {
  max-height: 300px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
